export const TRANSLATION_PREFIX = 'STATIC.PAGES.CUSTOM_METRICS';

export const NEW_METRIC_ID = 'new';
export const CELL_FORMAT_CUSTOM = 'CELL_FORMAT_CUSTOM';
export const CHOOSE_FORMAT_PLACEHOLDER = 'Choose a Format';
export const METRIC_NAME_MAX_LENGTH = 40;
export const TOOLTIP_MAX_LENGTH = 100;
export const SUCCESS_TOAST_AUTO_CLOSE = 10000;

export const OPERATOR_TYPES = {
    LIST: 'list',
    TEXT: 'text',
    DATE: 'date',
};

export const COHORT_METRIC_TYPE = 'all_cohort_metrics';
export const REF_TABLE_PREFIX = 'ref_table_';
export const CPE_SUM_RULE_KEY = 'is_cpe_sum_rule';
// Key in a reference table's visibility_cols marking that its rows name an event. Enabling it also makes the
// event required on every row (APIUtils.is_ref_table_event_required), which is what a sum rule needs.
export const REF_TABLE_EVENT_COLUMN = 'event';

export const DEFAULT_PERIOD = {
    display_name: '-',
    name: 'default',
    period_id: -99,
};

export const DEFAULT_OPERATOR = { name: '', operator: 'condition', type: OPERATOR_TYPES.TEXT };
export const DEFAULT_RESULT_OPERATOR = { name: '', operator: 'operator', type: OPERATOR_TYPES.TEXT };

export const getDefaultExpression = () => ({
    dimension: {},
    operator: { ...DEFAULT_OPERATOR },
    value: [],
});

export const getDefaultResult = () => ({
    metric: { display_name: '' },
    operator: { ...DEFAULT_RESULT_OPERATOR },
    value: '',
    isRefTable: false,
    showOpValue: false,
});

export const getDefaultRule = () => ({
    expression: [getDefaultExpression()],
    result: getDefaultResult(),
    isCpeSum: false,
});

export const getDefaultCustomMetric = () => ({
    id: NEW_METRIC_ID,
    name: '',
    display_name: '',
    oldName: null,
    visible: true,
    is_default: false,
    is_restricted: false,
    should_appear_as_custom_event: false,
    field_type: null,
    custom_display_format: {},
    json: '',
    tooltip: '',
    rules: [],
    default_result: getDefaultResult(),
    periods: {},
});
